import React, { Component } from 'react';

class ThingsToDoSkeleton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <React.Fragment>
        {Array.from(Array(2).keys()).map((i) => {
          return (
            <div key={i} className="article-item">
              <div className="image-container skeleton-shine" />
              <div className="content-container">
                <div className="article-category skeleton-shine" />
                <div className="article-date skeleton-shine" />
                <h3 className="article-title skeleton-shine" />
              </div>
            </div>
          );
        })}
      </React.Fragment>
    );
  }
}

export default ThingsToDoSkeleton;



// WEBPACK FOOTER //
// ./scripts/components/ThingsToDoSkeleton/ThingsToDoSkeleton.js